import type { ApiEnvelope } from '@/types/api.types';
import { apiClient } from '@lib/axios';

import type { BusinessHours } from '../types';

export async function getBusinessHours(accountId: string): Promise<BusinessHours> {
  const { data } = await apiClient.get<ApiEnvelope<BusinessHours>>(
    `/settings/accounts/${accountId}/hours`,
  );
  return data.data;
}

export async function putBusinessHours(
  accountId: string,
  body: BusinessHours,
): Promise<BusinessHours> {
  const { data } = await apiClient.put<ApiEnvelope<BusinessHours>>(
    `/settings/accounts/${accountId}/hours`,
    body,
  );
  return data.data;
}
